import {
  FETCH_SPRINT_HISTORY,
  FETCH_SPRINT_HISTORY_SUCCESS,
  FETCH_SPRINT_HISTORY_ERROR,
} from '../actions/types';

//todo paginate this
const DEFAULT_STATE = {
  data: null,
  loading: false,
  error: null
}

export default function(state = DEFAULT_STATE, action){
  // console.log('action received: ', action);
  switch(action.type){
    case FETCH_SPRINT_HISTORY:
      return {
        ...state,
        data: null,
        loading: true,
        error: null,
      }
    break;
    case FETCH_SPRINT_HISTORY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    break;
    case FETCH_SPRINT_HISTORY_ERROR:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.payload
      }
    break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/sprintHistoryReducer.js